import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import AdminLayout from "./AdminLayout";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import PagesList from "./pages/PagesList";
import PageEditor from "./pages/PageEditor";
import NewsList from "./pages/NewsList";
import NewsEditor from "./pages/NewsEditor";
import ResourcesList from "./pages/ResourcesList";
import ResourceEditor from "./pages/ResourceEditor";
import PartnersList from "./pages/PartnersList";
import PartnerEditor from "./pages/PartnerEditor";
import SettingsPage from "./pages/SettingsPage";
import Messages from "./pages/Messages";
import Account from "./pages/Account";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, mustChange } = useAuth();
  if (user === null)
    return (
      <div className="grid min-h-screen place-items-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-[hsl(var(--aoa-royal))]" />
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (mustChange && window.location.pathname !== "/admin/change-password") {
    return <Navigate to="/admin/change-password" replace />;
  }
  return children;
}

export default function AdminApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route
          path="change-password"
          element={
            <Protected>
              <ChangePassword />
            </Protected>
          }
        />
        <Route
          element={
            <Protected>
              <AdminLayout />
            </Protected>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="pages" element={<PagesList />} />
          <Route path="pages/:slug" element={<PageEditor />} />
          <Route path="news" element={<NewsList />} />
          <Route path="news/new" element={<NewsEditor />} />
          <Route path="news/:id" element={<NewsEditor />} />
          <Route path="resources" element={<ResourcesList />} />
          <Route path="resources/new" element={<ResourceEditor />} />
          <Route path="resources/:id" element={<ResourceEditor />} />
          <Route path="partners" element={<PartnersList />} />
          <Route path="partners/new" element={<PartnerEditor />} />
          <Route path="partners/:id" element={<PartnerEditor />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="messages" element={<Messages />} />
          <Route path="account" element={<Account />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
